export default "__VITE_ASSET__BrJmqsjd__"